import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { AppContext } from "../components/context/AppContext";
import { ArrowButton } from "./styled/ArrowButton";
import { Button } from "./styled/Button";
import { getDateAsString } from "../utils/Helpers";
import { ROUTE_PATHS } from "../utils/routes";
import AnalyticsService from "../utils/AnalyticsService";

export const TrackerRowComponent = withRouter(({ submission, history }) => {
  const [showPickUpBars, setShowPickupBars] = useState(false);
  const [showRewardBar, setShowRewardsBar] = useState(false);
  const [showRewardButton, setShowRewardButton] = useState(false);
  const [pendingValidation, setPendingValidation] = useState(false);
  const [completValidation, setCompletValidation] = useState(false);
  const [deniedValidationText, setDeniedValidationText] = useState(false);
  const [decisionPending, setDecisionPendingText] = useState(false);
  const [defaultText, setDefaultText] = useState(true);
  const [rewardLink, setRewardLink] = useState("");
  const [deniedValidationTextInfo, setDeniedValidationTextInfo] = useState([]);
  const [dayTextForPending, setDayTextForPending] = useState("");
  const { dispatch } = useContext(AppContext);

  const handleRowClick = (submission) => {
    AnalyticsService.sendGa4Event({ event: 'Promotions', trigger: "view", category: submission, action: "trackerComponent", label: "PromoCodeEntry" })
    dispatch({ type: "SETSELECTEDSUBMISSION", payload: submission })

    switch (submission.offer.offerId) {
      case 268795:
      case 268637:
        if (submission.instantValidationOffer === "INVALID" || submission.instantValidationOffer === "VALID") {
          history.push(`${ROUTE_PATHS.STATUS}/${Number(submission.submitId) === 0 ? submission.iSubmitId : submission.submitId}`)
        } else {
          handleFrontDoorRowClick(submission)
        }
        break;
      default:
        if (submission.instantValidationOffer === "INVALID" || submission.instantValidationOffer === undefined) {
          handleFrontDoorRowClick(submission)
        } else {
          history.push(`${ROUTE_PATHS.STATUS}/${Number(submission.submitId) === 0 ? submission.iSubmitId : submission.submitId}`)
        }
        break;
    }
  }

  const handleFrontDoorRowClick = (submission) => {
    AnalyticsService.sendGa4Event({
      event: "Promotions",
      trigger: "view",
      category: submission,
      action: "trackerComponent",
      label: "PromoCodeEntry",
    });
    dispatch({ type: "SETSELECTEDSUBMISSION", payload: submission });

    // Toggle showPickUpBars - if already open, close it and reset states
    if (showPickUpBars) {
      setShowPickupBars(false);
      setPendingValidation(false);
      setCompletValidation(false);
      setDeniedValidationText(false);
      setDecisionPendingText(false);
      setDefaultText(true);
      setShowRewardsBar(false);
      setShowRewardButton(false);
      return
    }

    setShowPickupBars(true);
    if (submission.redeemDays === "") {
      setDayTextForPending("")
    } else {
      setDayTextForPending(submission.redeemDays)
    }


    if (submission.statusId !== 3) {
      setDecisionPendingText(true)
    }

    if (submission.statusId !== 3 && submission.statusId !== 0) {
      setPendingValidation(true)
    }

    if (Number(submission.submitId) === 0) {
      setPendingValidation(false)
    }

    if (submission.statusId === 3 && submission.error === 0 && submission.valid === true && submission.debitCard === undefined) {
      setCompletValidation(true)
      setDefaultText(false)
    }

    if (submission.debitCard !== undefined) {
      setShowRewardsBar(true)
      setCompletValidation(true)
      setRewardLink(submission.debitCard.virtualPayClaimCode)
      setShowRewardButton(true)
      setDefaultText(false)
      return
    } else if (submission.statusId === 3 && submission.error === 0 && submission.valid === true && (submission.virtualPayClaimCode !== undefined || submission.virtualPayClaimCode !== "EMPTY")) {
      setShowRewardsBar(true)
      setCompletValidation(true)
      setRewardLink(submission.virtualPayClaimCode)
      setShowRewardButton(true)
      setDefaultText(false)
      return
    }

    if (submission.statusId === 3 && submission.error === 1 && submission.valid === false) {
      setCompletValidation(true)
      setShowRewardsBar(true)
      setDeniedValidationTextInfo(submission.offerErrors === undefined ? submission.description : submission.offerErrors)
      setDeniedValidationText(true)
      setDefaultText(false)
      return
    }

    if ((submission.statusId === 3 && submission.valid === true) && (submission.error === 1 || submission.error === 0)) {
      setCompletValidation(true)
      setDefaultText(false)
    }

    if (submission.statusId === 3 && submission.valid === false) {
      setCompletValidation(true)
      setShowRewardsBar(true)
      setDeniedValidationTextInfo(submission.offerErrors === undefined ? submission.description : submission.offerErrors)
      setDeniedValidationText(true)
      setDefaultText(false)
    }

    return
  };

  const handleRewardClick = () => {
    if (rewardLink !== "") {
      window.open(rewardLink, '_blank');
    }
  };

  return (
    <>
      <tr>
        <td style={{ textAlign: "center" }}>
          <Button onClick={(e) => handleRowClick(submission, e)} className="btn" primary>Details</Button>
        </td>
        <td data-label="Description" style={{ textAlign: "left" }}>{submission.offer.description}</td>
        <td data-label="Offer Value" style={{ textAlign: "left" }}>{submission.offer.offerValue}</td>
        <td data-label="Offer Date" style={{ textAlign: "left" }}>{getDateAsString(submission.stampDate)}</td>
      </tr>

      {showPickUpBars && (
        <tr >
          <td colSpan="5" style={{ padding: 0 }}>
            <div className={showRewardButton ? "four-buttons" : "three-buttons"} style={{
              display: "flex",
              gap: "0px",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "nowrap",
              padding: "5px",
              overflow: "hidden"
            }}>
              <ArrowButton
                className="btn"
                style={{ background: (submission.statusId === 0 && !pendingValidation) || (Number(submission.submitId) === 0 && !pendingValidation) ? "#e20074" : "#808080" }}
              >
                <div style={{ textAlign: "center", width: "100%", padding: "0 5px" }}>
                  <div style={{ fontSize: "inherit", marginBottom: "2px" }}>Request Received:</div>
                  <div style={{ fontSize: "inherit", marginBottom: "2px" }}>{getDateAsString(submission.stampDate)}</div>
                  <div style={{ fontSize: "0.9em", marginBottom: "2px" }}>Tracking: {submission.trackingId}</div>
                  <div style={{ fontStyle: "italic", fontSize: "0.85em" }}>Allow 24 hours to update</div>
                </div>
              </ArrowButton>

              <ArrowButton
                className="btn"
                style={{ background: pendingValidation ? "#da1279ff" : "#808080" }}
              >
                <div style={{ textAlign: "center", width: "100%", padding: "0 5px" }}>
                  <div style={{ fontSize: "inherit", marginBottom: "2px" }}>Pending Validation:</div>
                  <div style={{ fontSize: "inherit", marginBottom: "2px" }}>Allow {dayTextForPending}</div>
                  <div style={{ fontStyle: "italic", fontSize: "0.85em" }}>From Request Received</div>
                </div>
              </ArrowButton>

              <ArrowButton
                className="btn"
                style={{ background: completValidation && !showRewardButton ? "#da1279ff" : "#808080" }}
              >
                <div style={{ textAlign: "center", width: "100%", padding: "0 5px" }}>
                  {(defaultText || decisionPending) && (<div style={{ fontSize: "inherit" }}>Decision Pending</div>)}
                  {!deniedValidationText && completValidation && (<div style={{ fontSize: "inherit" }}>Request Approved</div>)}
                  {completValidation && deniedValidationText && (<div style={{ fontSize: "inherit" }}>Request Not Approved</div>)}
                </div>
              </ArrowButton>
              {showRewardBar && (
                <ArrowButton
                  className="btn"
                  primary
                  onClick={handleRewardClick}
                >
                  {!deniedValidationText && completValidation && (
                    <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <p style={{ fontSize: "inherit", textAlign: "center", width: "100%", margin: 0 }}>Get your Reward Now</p>
                    </div>
                  )}
                  {completValidation && deniedValidationText && (<div style={{ textAlign: "center", width: "100%", padding: "0 5px" }}>
                    {deniedValidationTextInfo.length === 0 && deniedValidationTextInfo !== "" && (<p style={{ fontSize: "inherit", marginBottom: "2px" }}>{deniedValidationTextInfo}</p>)}
                    {deniedValidationTextInfo.length >= 1 && deniedValidationTextInfo[0]?.description && (<p style={{ fontSize: "inherit", marginBottom: "2px" }}>{deniedValidationTextInfo[0].description}</p>)}
                    {deniedValidationTextInfo.length >= 2 && deniedValidationTextInfo[1]?.description && (<p style={{ fontSize: "inherit", marginBottom: "2px" }}>{deniedValidationTextInfo[1].description}</p>)}
                    {deniedValidationTextInfo.length >= 3 && deniedValidationTextInfo[2]?.description && (<p style={{ fontSize: "inherit", marginBottom: "2px" }}>{deniedValidationTextInfo[2].description}</p>)}
                    {deniedValidationTextInfo[0] === undefined && (<p style={{ fontSize: "inherit", marginBottom: "2px" }}>{deniedValidationTextInfo[0]}</p>)}
                    {deniedValidationTextInfo[1] === undefined && (<p style={{ fontSize: "inherit", marginBottom: "2px" }}>{deniedValidationTextInfo[1]}</p>)}
                    {deniedValidationTextInfo[2] === undefined && (<p style={{ fontStyle: "italic", fontSize: "0.85em" }}>{deniedValidationTextInfo[2]}</p>)}
                  </div>)}
                </ArrowButton>
              )}
            </div>
          </td>
        </tr>
      )}
    </>
  );
});

TrackerRowComponent.propTypes = {
  submission: PropTypes.object.isRequired,
};


